import { GlobalModalOptions } from './actions';

export const getModal = (state: any): GlobalModalOptions => state.modal;
